import { createApp } from 'vue'
import Temperature from './Temperature.vue'
import './assets/global.css'

createApp(Temperature).mount('#temperature')
